<div class="dialog-container">
  <ng-container *ngIf="isEditMode; else pageContent">
    <h2 class="dialog-title">Edit Topic</h2>
    <span class="topic">Update the topic and its subtopics.</span>
  </ng-container>

  <ng-template #pageContent>
    <h2 class="dialog-title">Add New Topic</h2>
    <span class="topic">Create a new topic with subtopics.</span>
  </ng-template>

  <div class="scroll-area">
    <form [formGroup]="topicForm">
      <label class="field-label">Topic Title <span class="required">*</span></label>
      <input
        type="text"
        class="input-box"
        formControlName="topic_title"
        placeholder="Topic"/>

      <label class="field-label"
        >Topic Description <span class="required">*</span></label>
      <textarea
        class="input-box textarea-box"
        rows="4"
        formControlName="description"
        placeholder="Description">
      </textarea>

      <div class="d-flex justify-content-between">
        <label class="field-label">Subtopic </label>
        <button
          type="button"
          class="add-subtopic-btn"
          (click)="addSubtopic()">
          + Add Subtopic
        </button>
      </div>

      <div formArrayName="subtopics">
        <div
          class="subtopic-card"
          *ngFor="let sub of subtopics.controls; let i = index"
          [formGroupName]="i">
		      <div class="subtopic-title mb-3">Subtopic {{ i + 1 }}</div>
          <div class="subtopic-header">
            <input
              type="text"
              class="input-box"
              formControlName="subtopic_title"
              placeholder="Subtopic"/>

            <button
              class="delete-btn"
              type="button"
              (click)="removeSubtopic(i)">
              <i class="bi bi-trash-fill"></i>
            </button>
          </div>

          <textarea
            class="input-box textarea-box"
            rows="4"
            formControlName="description"
            placeholder="Description">
          </textarea>

<div formArrayName="reference_links">
	      <div class="d-flex justify-content-between">
  <label class="field-label">Reference Links</label>
  
   <button
    type="button"
    class="add-subtopic-btn"
    (click)="addReferenceLink(i)">
    + Add Reference Link
  </button>
</div>
  <div
    *ngFor="let link of getReferenceLinks(i).controls; let j = index"
    [formGroupName]="j"
    class="reference-row">
          <div class="subtopic-header">
    <input
      type="text"
      class="input-box"
      formControlName="url"
      placeholder="Enter Reference URL" />

    <button
      type="button"
      class="delete-btn"
      (click)="removeReferenceLink(i, j)">
      <i class="bi bi-trash-fill"></i>
    </button>
	</div>
  </div>
</div>
        </div>
      </div>
    </form>
  </div>

 <div class="dialog-actions">
  <button class="close" (click)="close()">Cancel</button>
  <button class="btn-add" (click)="save()">Save Changes</button>
</div>

</div>